import React from "react";
import { Box, Stack, Typography } from "@mui/material";

export interface ProfileSectionTitleProps {
  title: string;
  stackSx?: object;
  /** Rendered at the end of the row (e.g. button). */
  action?: React.ReactNode;
}

/**
 * Section heading: `h2` + optional action aligned to the end.
 */
export const ProfileSectionTitle: React.FC<ProfileSectionTitleProps> = ({
  title,
  stackSx,
  action,
}) => (
  <Stack direction="row" alignItems="center" spacing={2} sx={stackSx}>
    <Typography variant="h2" component="h2">
      {title}
    </Typography>
    {action ? <Box sx={{ flex: 1, minWidth: 0 }} /> : null}
    {action}
  </Stack>
);
